import $ from 'jquery';

export default function() {
  if ($('.robin-nav').length > 0) {
    // Styles the nav parent folder that the user is viewing
    $('a').each(function() {
      if ($(this).prop('href') == window.location.href) {
        $(this).addClass('current');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/webpack/utils/navigation-active.js